module.exports =  {
  tags:{
    adtag:'v1.4',
  },
  autoBreadcrumbs: {
    'xhr': false,      // XMLHttpRequest
    'console': false,  // console logging
    'dom': false,      // DOM interactions, i.e. clicks/typing
    'location': false  // url changes, including pushState/popState
  },
  ignoreErrors: [
    // Random plugins/extensions
    'top.GLOBALS',
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error. html
    'originalCreateNotification',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    'http://tt.epicplay.com',
    'Can\'t find variable: ZiteReader',
    'jigsaw is not defined',
    'ComboSearch is not defined',
    'http://loading.retry.widdit.com/',
    'atomicFindClose',
    // Facebook borked
    'fb_xd_fragment',
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
    // reduce this. (thanks @acdha)
    // See http://stackoverflow.com/questions/4113268
    'bmi_SafeAddOnload',
    'EBCallBackMessageReceived',
    // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
    'conduitPage',
    // IE Error. (The cause is unknown)
    'Can\'t execute code from a freed script',
    '解放されたスクリプトからコードを実行できません'
  ],
  // ignoreUrls: [
  //   // Facebook flakiness
  //   /graph\.facebook\.com/i,
  //   // Facebook blocked
  //   /connect\.facebook\.net\/en_US\/all\.js/i,
  //   // Woopra flakiness
  //   /eatdifferent\.com\.woopra-ns\.com/i,
  //   /static\.woopra\.com\/js\/woopra\.js/i,
  //   // Chrome extensions
  //   /extensions\//i,
  //   /^chrome:\/\//i,
  //   // Other plugins
  //   /127\.0\.0\.1:4001\/isrunning/i,  // Cacaoweb
  //   /webappstoolbarba\.texthelp\.com\//i,
  //   /metrics\.itunes\.apple\.com\.edgesuite\.net\//i
  // ]
  // UZOUのjsだけをエラー収集の対象にする
  // TODO: ローカル実行時でもエラー収集の対象になるようにファイル名を直接指定しているが、
  // ファイルが増えた際に望ましくないので後日別の方式に変更する。
  // (config.jsonにakamaiのパスを移行する等の改修もその際に行う)
  whitelistUrls: [/outer-frame\.min\.js/, /inner-frame\.min\.js/]
};



// WEBPACK FOOTER //
// ./src/js/raven/raven-options.js